export type LoadFlow = 'auto-confirm' | 'show-manifest'

/**
 * Показать ли подтверждающую модалку перед докачкой, или сразу гнать пайплайн.
 *
 * ВСЕГДА `auto-confirm` (фидбек владельца 2026-07-27, обе страницы «Карты»/
 * «Модели»): кнопка загрузки данных на карте не должна задавать лишний вопрос —
 * любое нажатие сразу качает недостающее, пересчитывает и перерисовывает тайлы,
 * прогресс виден на самой кнопке. Раньше окно «Докачать и показать» оставалось
 * на ПЕРВОЙ загрузке с недостающими данными — его и убрали.
 *
 * Аргументы (`refresh`, `needsDownload`) и вариант `show-manifest` сохранены для
 * совместимости вызывающего кода, но на решение больше не влияют.
 */
export function resolveLoadFlow(_o: { refresh: boolean; needsDownload: boolean }): LoadFlow {
  return 'auto-confirm'
}
